export default "__VITE_ASSET__DbiYNJzT__"